import selectorDefinitions from './selectors.js';
import eventReducers from './reducers.js';
const initialState = {
    isLoading: true,
    isLocked: true,
    isBackedUp: true,
    walletExists: true,
    hasPassphraseSet: true,
    isRestoring: false,
    lockHistory: [],
    autoLockTimer: null,
    walletCreatedAt: null,
};
const applicationReduxDefinition = {
    id: 'application',
    type: 'redux-module',
    initialState,
    eventReducers,
    selectorDefinitions,
};
export default applicationReduxDefinition;
